module.exports = __webpack_public_path__ + "static/img/keyanhuitu.ea38dfeb.jpg";